import { Line, mixins } from 'vue-chartjs'

export default {
    extends: Line,
    mixins: [mixins.reactiveProp],
    props: ['chartData', 'isLegendVisible'],
    mounted() {
        this.addPlugin({
            beforeInit: function(chart, options) {
              chart.legend.afterFit = function() {
                this.height = this.height + 30;
              };
            }
        })
        this.renderChart(
            this.chartData,
            {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            stepSize: 1,
                        }
                    }]
                },
                legend: {
                    display: this.isLegendVisible,
                    align: 'start',
                    labels: {
                        padding: 15,
                        usePointStyle: true
                    }
                },
                elements: {
                    point: {
                        borderWidth: 3,
                        pointStyle: 'rect',
                    },
                    line: {
                        tension: 0
                    }
                },
                maintainAspectRatio: false
            }
        );
    }
}